import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { ITeam } from './team';
import {
  fetchTeamsList
} from './list.thunks';

export interface TeamListState {
  teams: ITeam[];
  totalCount: number;
  unsorted: ITeam[];
  loading: boolean;
  error: ApiError | null;
  editingTeam: string;
}

const initialState: TeamListState = {
  error: null,
  loading: false,
  teams: [],
  totalCount: 0,
  unsorted: [],
  editingTeam: ''
};

const getTeamListState = (state:RootState):TeamListState => state.teams.list;
const getError = (state:RootState):ApiError | null => getTeamListState(state).error;
const getList = (state:RootState):ITeam[] => getTeamListState(state).teams;
const getTotalCount = (state:RootState):number => getTeamListState(state).totalCount;
const getUnsortedList = (state:RootState):ITeam[] => getTeamListState(state).unsorted;
const getLoading = (state:RootState):boolean => getTeamListState(state).loading;
const getEditingTeamId = (state:RootState):string => getTeamListState(state).editingTeam;

export const selectors = {
  getError,
  getList,
  getTotalCount,
  getUnsortedList,
  getLoading,
  getEditingTeamId
};

export const extraReducers = {
  [fetchTeamsList.pending.type]: (state: TeamListState):void => {
    state.loading = true;
    state.totalCount = 0;
    state.teams = [];
    state.unsorted = [];
  },
  [fetchTeamsList.fulfilled.type]: (state: TeamListState, action: AnyAction):void => {
    state.loading = false;
    state.totalCount = action.payload.count ?? (action.payload.teams ? action.payload.teams.length : 0 );
    state.teams = action.payload.teams;
    state.unsorted = [...(action.payload.teams || [])];
  },
  [fetchTeamsList.rejected.type]: (state: TeamListState, action: AnyAction):void => {
    state.loading = false;
    state.error = action.payload;
  }
};

export type UpdateListPayload = {
  newList: ITeam[];
}

export type UpdateTableQueryPayload = string;

const teamsListSlice = createSlice({
  name: 'teamsList',
  initialState,
  reducers: {
    setEditingTeam: (state:TeamListState, action: PayloadAction<string>) => {
      state.editingTeam = action.payload;
    },
    clearEditingTeam: (state:TeamListState) => {
      state.editingTeam = '';
    },
    updateTeam: (state:TeamListState, action:PayloadAction<ITeam>) => {
      const udpatedTeam = action.payload;
      state.unsorted = state.unsorted.map(team => team.id === udpatedTeam.id ? { ...team, ...udpatedTeam } : team);
      state.teams = [...state.unsorted];
    }
  },
  extraReducers
});

export default teamsListSlice.reducer;
export const actions = {
  ...teamsListSlice.actions,
  fetchTeamsList
};
